'use strict';

import { AGENT_STATE } from '@/constants/agent/constants';
import store from '@/store';

/**
 * EcsState
 * Ref. https://support.evolveip.net/display/proddev/2.04+Agent+Interaction+Summary+Report
 **/

export default class EcsState {
  constructor({ stateId, stateName, reasonCode = '', breakDuration, timestamp }) {
    this.stateId = stateId;
    this.stateName = stateName;
    this.reasonCode = reasonCode;
    this.breakDuration = breakDuration;
    this.stateChangeTimestamp = timestamp;
  }

  static get readyStateIds() {
    return [AGENT_STATE.ready, AGENT_STATE.offered];
  }

  static get busyStateIds() {
    return [
      AGENT_STATE.busy,
      AGENT_STATE.dialing,
      AGENT_STATE.waitingForBackoffice,
      AGENT_STATE.waitingForOutgoing,
      AGENT_STATE.waitingForBreak,
      AGENT_STATE.waitingForOffline
    ];
  }

  static get breakStateIds() {
    const availableCustomBreakStates = ((store.getters || {})['REFERENCES/availableCustomBreakStates'] || []).map(
      state => state.id
    );
    return [AGENT_STATE.break, AGENT_STATE.noAnswer, ...availableCustomBreakStates];
  }

  static get offlineStateIds() {
    return [AGENT_STATE.offline, ''];
  }

  static get outgoingStateIds() {
    return [AGENT_STATE.outgoing];
  }

  static get backofficeStateIds() {
    return [AGENT_STATE.backoffice];
  }

  get isBusy() {
    return EcsState.busyStateIds.includes(this.stateId);
  }

  get isBreak() {
    return EcsState.breakStateIds.includes(this.stateId);
  }

  get isReady() {
    return EcsState.readyStateIds.includes(this.stateId);
  }

  get isBackoffice() {
    return AGENT_STATE.backoffice === this.stateId;
  }

  get isOutgoing() {
    return AGENT_STATE.outgoing === this.stateId;
  }

  get isPreview() {
    return AGENT_STATE.outgoing === this.stateId;
  }

  get isDialing() {
    return AGENT_STATE.dialing === this.stateId;
  }

  get isNoAnswer() {
    return AGENT_STATE.noAnswer === this.stateId;
  }

  get isOffline() {
    return AGENT_STATE.offline === this.stateId;
  }

  get isOnline() {
    return !this.isOffline;
  }

  get isRinging() {
    return AGENT_STATE.offered === this.stateId;
  }
}
